import React from "react"
import {
  Heading,
  Text,
  UnorderedList,
  OrderedList,
  ListItem,
  Alert,
  VStack,
} from "@chakra-ui/react"
import { MDXProvider as Provider } from "@mdx-js/react"

function H1(props) {
  return <Heading as="h2" size="4xl" w="full" {...props} />
}

function H2(props) {
  return <Heading as="h3" size="2xl" w="full" {...props} />
}

function H3(props) {
  return <Heading as="h4" size="lg" w="full" {...props} />
}

function P(props) {
  return <Text size="md" w="full" {...props} />
}

function OL(props) {
  return <OrderedList pl={4} w="full" {...props} />
}

function UL(props) {
  return <UnorderedList pl={4} w="full" {...props} />
}

function LI(props) {
  return <ListItem w="full" {...props} />
}

function BlockQuote(props) {
  return (
    <Alert
      variant="left-accent"
      colorScheme="primary"
      alignItems="flex-start"
      flexDirection="column"
      as="blockquote"
      rounded={5}
      role="none"
      w="full"
      {...props}
    >
      <VStack w="full" spacing={4}>
        {props.children}
      </VStack>
    </Alert>
  )
}

const map = {
  h1: H1,
  h2: H2,
  h3: H3,
  p: P,
  ol: OL,
  ul: UL,
  li: LI,
  blockquote: BlockQuote,
}

export function MDXProvider({ children }) {
  return <Provider components={map}>{children}</Provider>
}
